import request from "../utils/requestLive";

export async function getUserLessons({ limit, max, anchorId }) {
  return request({
    method: "get",
    url: `/api/v1/anchor/${anchorId}/lives`,
    query: {
      limit,
      max,
    },
  });
}
// 获取课程列表
export async function getLiveList({ limit, id, cookie }) {
  return request({
    method: "get",
    url: `/api/v1/category/${id}/lives`,
    query: {
      limit,
    },
    ignoreError: true,
    ignoreMessage: true,
    ...(cookie
      ? {
          headers: {
            cookie,
          },
        }
      : {}),
  });
}
// 预约课程
export async function purchaseFree({ id }) {
  return request({
    method: "post",
    url: `/api/v1/live/${id}/purchase/free`,
  });
}
export async function getLiveInfo(id) {
  return request({
    url: `/api/v1/live/${id}`,
  });
}
// 取消预约
export async function purchaseCancel({ id }) {
  return request({
    method: "post",
    url: `/api/v1/live/${id}/purchase/cancel`,
  });
}
